import * as React from 'react';
import { Messages } from '../../codegen/Localize';
import { TabStyles } from '@tableau/widgets';
import { cssClass } from '../../style';

export interface ReactConfirmActionStringBodyProps {
  readonly message: string;
}

export const ReactConfirmActionStringBody = (props: ReactConfirmActionStringBodyProps): JSX.Element => {
  return (
    <>
      {props.message}
    </>
  );
};

export const ReactAreYouSureConfirmActionStringBody = (props: ReactConfirmActionStringBodyProps): JSX.Element => {
  return (
    <div className={AreYouSureContainer}>
      <div className={AreYouSureHeader}>
        {Messages.confirmAreYouSure()}
      </div>
      {props.message}
    </div>
  );
};

const AreYouSureContainer = cssClass('confirm-action-dialog', 'are-you-sure-container', {
  textAlign: 'center',
  marginTop: TabStyles.Spacing.LargeSpace
});

const AreYouSureHeader = cssClass('confirm-action-dialog', 'are-you-sure-container', {
  fontWeight: 'bold',
  fontSize: TabStyles.Typography.Sizing.XLarge,
  marginBottom: TabStyles.Spacing.LargeSpace
});
